/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Updated_ToastInputs */

const en_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event speaker updated successfully`)
};

const fr_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervenant de l'evenement mis a jour avec succes`)
};

const de_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsredner erfolgreich aktualisiert`)
};

const it_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatore dell'evento aggiornato con successo`)
};

const ru_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация о докладчике мероприятия успешно обновлена.`)
};

const es_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El orador del evento se actualizó correctamente`)
};

const zh_cn2_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动演讲者信息已成功更新`)
};

const ja_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのスピーカーが正常に更新されました`)
};

const hi_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट स्पीकर सफलतापूर्वक अपडेट हो गया`)
};

const pt_pt2_speakers_updated_toast = /** @type {(inputs: Speakers_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrante do evento atualizado com sucesso`)
};

/**
* | output |
* | --- |
* | "Event speaker updated successfully" |
*
* @param {Speakers_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_updated_toast = /** @type {((inputs?: Speakers_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_updated_toast(inputs)
	if (locale === "de") return de_speakers_updated_toast(inputs)
	if (locale === "it") return it_speakers_updated_toast(inputs)
	if (locale === "ru") return ru_speakers_updated_toast(inputs)
	if (locale === "es") return es_speakers_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_updated_toast(inputs)
	if (locale === "ja") return ja_speakers_updated_toast(inputs)
	if (locale === "hi") return hi_speakers_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_updated_toast(inputs)
	return en_speakers_updated_toast(inputs)
});